import React, { Component, Fragment } from 'react';
import { Card, Icon, Tag, Alert } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class IndicatorsView extends Component {
    render() {
        return (
            <div>
                {this.renderSection(this.props.store.odysseyBotStore.longStrategy, 'Long Strategy')}

                {this.renderSection(
                    this.props.store.odysseyBotStore.shortStrategy,
                    'Short Strategy'
                )}

                {this.renderSection(
                    this.props.store.odysseyBotStore.taStrategy,
                    'Position: Technical Analysis - Exit'
                )}
            </div>
        );
    }

    renderSection(data, title) {
        if (!data || !data.groupResponses) return null;
        return data.groupResponses.map((group, groupId) => {
            return (
                <Card
                    title={`${title}: ${group.group_name}`}
                    bordered={false}
                    key={groupId}
                    style={{ marginBottom: 15 }}
                >
                    <div style={{ marginBottom: 5 }}>
                        Consensus:{' '}
                        <Tag color={group.signal.hasSignal ? '#436b45' : null}>
                            {group.signal.concensus}/{group.signal.min_concensus}
                        </Tag>
                        &nbsp;&nbsp;Required Consensus:{' '}
                        <Tag>
                            {group.signal.required_concensus}/{group.signal.min_required_concensus}
                        </Tag>{' '}
                        {data.meta && data.meta.hide_indicators ? null : (
                            <Fragment>
                                &nbsp;&nbsp;&nbsp;&nbsp;Current Price: {group.signal.current_price}
                                &nbsp;&nbsp;&nbsp;&nbsp;Signal Price:{' '}
                                {group.signal.signal_price.toFixed(4)}
                            </Fragment>
                        )}
                    </div>

                    {data.meta && data.meta.hide_indicators ? (
                        <Alert
                            style={{ marginTop: 10 }}
                            message="The author has restricted the ability to view indicator output"
                            type="warning"
                            icon={<Icon type="lock" />}
                            showIcon
                        />
                    ) : (
                        <Fragment>
                            <div style={{ marginLeft: 15 }}>
                                {this.renderSignals(group.signal.signals)}
                            </div>
                            <div style={{ textAlign: 'right' }}>{group.signal.updated_at}</div>
                        </Fragment>
                    )}
                </Card>
            );
        });
    }
    renderSignals(signals) {
        if (!signals) return;

        return signals
            .slice()
            .sort((a, b) => {
                if (!a || !b) {
                    console.log(a, b);
                    return -1;
                }
                return b.fired - a.fired;
            })
            .map((signal, i) => {
                if (!signal) {
                    return (
                        <div key={i} style={{ marginBottom: 8 }}>
                            Error with signal, check signal configuration
                        </div>
                    );
                }

                return (
                    <div key={i} style={{ marginBottom: 8 }}>
                        {signal.fired ? (
                            <Icon
                                type="check-circle"
                                theme="filled"
                                style={{ color: '#436b45', marginRight: 5 }}
                            />
                        ) : (
                            <Icon
                                type="close-circle"
                                theme="filled"
                                style={{ color: '#ba7272', marginRight: 5 }}
                            />
                        )}
                        Candle: {signal.candles_back === 0 ? 'Last' : signal.candles_back}{' '}
                        {signal.a_label}: <Tag>{signal.a}</Tag> {this.getClause(signal.clause)}{' '}
                        {signal.b_label}: <Tag>{signal.b}</Tag>
                    </div>
                );
            });
    }

    getClause(clause) {
        switch (clause) {
            case 'eq':
                return 'Equals';
            case 'lt':
                return 'Less than';
            case 'lte':
                return 'Less than or equals';
            case 'gt':
                return 'Greater than';
            case 'gte':
                return 'Greater than or equals';
            case 'cross_above':
                return 'Cross above';
            case 'cross_below':
                return 'Cross below';
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/IndicatorsView/index.js